module.exports = __webpack_public_path__ + "static/media/heart-bg-red.0ec35839.svg";